import { Domain, initialDomain } from '@engagement/core/store/domain/domain.model';
import { Action, createReducer, on } from '@ngrx/store';

import { DomainAction } from './domain.dispatcher';

const domainReducer = createReducer(
  initialDomain,
  on(DomainAction.LoadSuccess, DomainAction.Change, (state, { domain }) => ({
    ...state,
    ...domain,
  }))
);

export function reducer(state: Domain | undefined, action: Action) {
  return domainReducer(state, action);
}
